export abstract class OrganizeUserStepBaseComponent {
    abstract isValid(): boolean;
    abstract toReadableData();
    abstract toApiData();
    public hasNavigation: boolean;
    public formId;
}
